import { PhoneNumberLoginOrRegiste } from  '../api/public'
import { cookiesList, setCookie} from '../utils/cookies'
import store from '../store'
import router from '../router'
import { Message } from 'element-ui'

export function autoLogin(phone, code) {
    PhoneNumberLoginOrRegiste({
        phone,
        code
    }).then(res => {
        if (res.errorCode == 200) {
            store.dispatch('setLoginInfo', {
                ...res.data,
                account: res.data.account || phone
            })
            if (res.data.hasPwd == 'true') {
                setCookie(cookiesList.has_password, 'true')
            } else {
                setCookie(cookiesList.has_password, 'false')
            }
            if (res.data.type == '1') {
               router.push('/supplier')
            } else if (res.data.type == '2') {
               router.push('/dealer')
            } else {
               router.push('/supplier')
            } 
        } else {
            Message.error(res.errorMsg || '登录异常')
            store.dispatch('logOut', 2)
        }
    }).catch(err => {
        console.log(err)
    })
}